<template>
  <v-container fluid class="pa-0 ma-0">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" justify="center" align="center">
        <v-img
          width="100%"
          :src="require('@/assets/imgs/' + imgNmae)"
          max-height="265"
          gradient="to left,  rgba(0, 0, 0, 0.2) ,rgba(0, 0, 0, .2)"
        >
          <v-row justify="center" align="center" style="height: 100%">
            <v-col cols="12" justify="center" align="center">
              <div class="header">
                <span>Product Solutions</span>
              </div>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      align="center"
      :class="$vuetify.breakpoint.mdAndDown ? 'px-6' : 'px-12'"
      class="mt-4"
    >
      <p
        class="artice-text text-center"
        :class="$vuetify.breakpoint.mdAndDown ? '' : 'px-16'"
      >
        Finding the right software or applications to fit the needs of your firm
        can be a daunting task. You are investing in the future of your firm. We
        work with a large network of top technology vendors and have decades of
        experience to help you make the best decision to fit your requirements
        and budget. If you would like to schedule a demo or learn more about a
        product, we are here to assist you.
      </p>
    </v-row>
    <ProductsExpansionPanel />
  </v-container>
</template>

<script>
import ProductsExpansionPanel from '@/components/products/ProductsExpansionPanel.vue'
export default {
  components: { ProductsExpansionPanel },

  data() {
    return {
      imgNmae: "products.jpg",
    };
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 54px;
  color: rgb(253, 250, 250);
}
</style>